export interface IDeviceStatus {
    AppVersion: string
    OS: EMobileOS
    Description: string
    StatusTime: string
    Log: string
    WiFi: boolean
    Cellular: boolean
    EstimatedConnectionSpeedKBPS: number
    NotificationToken: string
    DevicePermissions: IDevicePermissions
}

export enum EMobileOS {
    iOS = 0,
    Android = 1
}

export interface IDevicePermissions {    
    Location: boolean
    PreciseLocation: boolean
    Camera: boolean
    Storate: boolean
    PhoneCalls: boolean
    NFC: boolean
    PhotoLibrary: boolean
}